<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="300px">
        <form>
          <v-card color="grey lighten-5">
            <v-flex xs12 sm12>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
              </v-toolbar>
            </v-flex>
            <v-card-text>

              <v-form ref="formreferans" v-model="valid" lazy-validation>
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>

                        <v-layout wrap>
                          <div class="flex md12">
                            <div v-show="codegorunum === true ">
                              <v-text-field :label="$t('Reference-Code')" :rules="[v => !!v || $t('This-space-cannot-left-blank')]"
                                :color="color" v-model="Referans.Kod" required></v-text-field>
                            </div>
                            <v-text-field :label="$t('Reference-Name')" :rules="[v => !!v || $t('This-space-cannot-left-blank')]"
                              :color="color" v-model="Referans.ReferansAd" required></v-text-field>
                          </div>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-show="m === true">


                <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deletereferans()" flat>
                    <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                    </span>
                  </v-btn>
                  <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
                </v-tooltip>

                <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                    <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                    </span>
                  </v-btn>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                </v-tooltip>


              </div>
              <div v-show="k === true">
                <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                      class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                    </span>
                  </v-btn>
                  <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
                </v-tooltip>



              </div>
              <v-btn color="blue darken-1" flat @click.native="dialog = false">{{$t('Cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title class="baslikfont">{{$t('Reference')}} </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-text-field flat="" solo-inverted="" hide-details v-model="search3"  :label="$t('Please-enter-3-letters')" append-icon="search">  </v-text-field>-->
          <v-text-field flat="" solo-inverted="" hide-details autofocus="" ref="ara" v-model="secilendeger" :label="$t('Please-enter-3-letters')" append-icon="search"></v-text-field>
       
        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="referansekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Add-v2', { value: $t('Reference')}) }} </span>
            </span>
            <v-icon right dark>add_box</v-icon>

          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Reference')}) }}</span>
        </v-tooltip>

      </v-toolbar>
    </v-layout>



    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3" >
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>


        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.Kod)" item>
            <td class="text-xs-left">{{ props.item.KayitTarihi }}</td>
            <td class="text-xs-left">{{ props.item.Kod }}</td>
            <td class="text-xs-left">{{ props.item.ReferansAd }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">

          {{ $t('No-records-searched-for', { value: search3}) }}

        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import VeeValidate from '../../../../node_modules/vee-validate'
  import Vue from 'vue'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  Vue.use(VeeValidate)

  export default {
    data() {
      return {
        secilendeger: null,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: this.$t('Registration-Date'),
            value: 'KayitTarihi',
            sortable: false
            
          },
          {
            text: this.$t('Reference-Code'),
            value: 'Kod',
            sortable: false
          },
          {
            text: this.$t('Reference-Name'),
            value: 'ReferansAd',
            sortable: false
          },
        ],

        items: [],
        color: 'orange darken-4',

        selected: '',
        search3: '',
        m: false,
        k: false,
        dialog: false,
        valid: true,

        Referans: {
          Kod: null,
          ReferansAd: null,
          CompanyCode: null,
        },

        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
      }
    },
    watch: {
      'secilendeger': kayitgetir,
      //'Query.q': tumListe,

    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
   
    mounted() {
      this.$validator.localize('tr', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        // var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        // var params = {
        //   CompanyCode: credentials.SirketKodu,
        // }

        // this.progress = true
        // this.$http.post(auth.API_URL + 'api/Reference/List', params, {
        //   headers: {
        //     'Authorization': 'Bearer ' + auth.getAuthHeader()
        //   }
        // }).then((response) => {
        //   this.progress = false
        //   this.items = response.body
        // }, (response) => {
        //   if (response.status === 0) {
        //     this.text1 = 'Service Unavailable'
        //     this.snackbar = true
        //   } else {
        //     this.text1 = 'Service Unavailable'
        //     this.snackbar = true
        //   }
        // })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    methods: {
     
      Getir(v) {
        
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Referans Güncelle'
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
          Kod: v
        }
        this.$http.post(auth.API_URL + 'api/Reference/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Referans = response.body[0]
        })
      },
      deletereferans: deletereferans,
      referansekle: referansekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog
    },
  }

  function Kaydet() {
    if (this.$refs.formreferans.validate()) {


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params1 = {
        CompanyCode: credentials.SirketKodu,
      }

      this.Referans.CompanyCode = credentials.SirketKodu

      var params = this.Referans



      this.$http.post(auth.API_URL + 'api/Reference/Add', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        var message=response.body.ResponseMessage;
        if (response.body.Status) {
            this.dialog = false
            this.text1 = this.$t(message)
            this.snackbar = true
             

            var y=this.secilendeger;
if (y != null) {
var coper=false;
  if (y.length > 2) {

    this.progress = true
    var companyCode = null;
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    if(coper){
      companyCode = credentials.CoperSirketNo
    }else{
      companyCode = credentials.SirketKodu
    }
    var params1 = {
      CompanyCode: companyCode,
      Search: escape(y),
      Coper: coper
    }
    this.$http.post(auth.API_URL + 'api/Reference/ReferenceSearch', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body

      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
        this.progress = false
      }
    })
  } else {
    this.items = []
    this.progress = false
  }

}

         
        } else {
            this.text1 = this.$t(message)
            this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })



    }


  }

  function referansekle() {
    this.$validator.reset()
    this.dialog = true
    this.Referans.ReferansAd = ''
    this.Referans.Kod = ''
    this.dialog_baslik = 'Referans Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
  }
  function kayitgetir() {
var y=this.secilendeger;
if (y != null) {
var coper=false;
  if (y.length > 2) {

    this.progress = true
    var companyCode = null;
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    if(coper){
      companyCode = credentials.CoperSirketNo
    }else{
      companyCode = credentials.SirketKodu
    }
    var params1 = {
      CompanyCode: companyCode,
      Search: escape(y),
      Coper: coper
    }
    this.$http.post(auth.API_URL + 'api/Reference/ReferenceSearch', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body

      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
        this.progress = false
      }
    })
  } else {
    this.items = []
    this.progress = false
  }

}
}
  function beforeMount() {

  }

  function deletereferans() {

    if (window.confirm('Referans\'ı silmek istediğinizden eminmisiniz?')) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));


      var params1 = {
        CompanyCode: credentials.SirketKodu,
      }
      this.Referans.CompanyCode = credentials.SirketKodu


      var params = this.Referans

      this.$http.post(auth.API_URL + 'api/Reference/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        var message=response.body.ResponseMessage;
        if (response.body.Status) {
          this.text1 = message
          this.snackbar = true
          this.dialog=false
          

          
var y=this.secilendeger;
if (y != null) {
var coper=false;
  if (y.length > 2) {

    this.progress = true
    var companyCode = null;
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    if(coper){
      companyCode = credentials.CoperSirketNo
    }else{
      companyCode = credentials.SirketKodu
    }
    var params1 = {
      CompanyCode: companyCode,
      Search: escape(y),
      Coper: coper
    }
    this.$http.post(auth.API_URL + 'api/Reference/ReferenceSearch', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body

      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
        this.progress = false
      }
    })
  } else {
    this.items = []
    this.progress = false
  }

}




        } else {
          this.text1 = message
          this.snackbar = true
          this.dialog=false
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    if (this.$refs.formreferans.validate()) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));


      var params1 = {
        CompanyCode: credentials.SirketKodu,
      }
      this.Referans.CompanyCode = credentials.SirketKodu
      var params = this.Referans
      this.codegorunum = false
      this.$http.post(auth.API_URL + 'api/Reference/Update', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        var message=response.body.ResponseMessage;
        if (response.body.Status) {
          this.text1 = message
          this.snackbar = true
          this.dialog=false
          

          var y=this.secilendeger;
if (y != null) {
var coper=false;
  if (y.length > 2) {

    this.progress = true
    var companyCode = null;
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    if(coper){
      companyCode = credentials.CoperSirketNo
    }else{
      companyCode = credentials.SirketKodu
    }
    var params1 = {
      CompanyCode: companyCode,
      Search: escape(y),
      Coper: coper
    }
    this.$http.post(auth.API_URL + 'api/Reference/ReferenceSearch', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body

      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
        this.progress = false
      }
    })
  } else {
    this.items = []
    this.progress = false
  }

}



        } else {
          this.text1 = message
          this.snackbar = true

        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
    }
  }
</script>

<style>

</style>